import { api } from 'utility';
import axios from 'axios';
import { getBusinessDealerServiceUrl } from 'URLs';
class DealerListServices {
  axios;

  source;

  CancelToken;

  constructor() {
    this.CancelToken = axios.CancelToken;
  }

  async getDealerList(obj) {
    if (this.source) {
      this.source.cancel();
    }

    this.source = this.CancelToken.source();

    const params = { offset: 0, size: 10, ...obj };

    return api
      .get(getBusinessDealerServiceUrl(), {
        params,
        cancelToken: this.source.token,
      })
      .then((res) => res.data);
  }
}

const dealerListServices = new DealerListServices();
export default dealerListServices;
